export default "__VITE_ASSET__pY0kulfj__"